'use strict';

ngtk.Debouncer = Class({

    $inject: ['$timeout', '$q'],

    $timeout: null,
    $q: null,

    construct: function($timeout, $q) {
        this.$timeout = $timeout;
        this.$q = $q;
    },

    debounce: function(func, wait, immediate) {
        var timeout;
        var deferred = this.$q.defer();
        return function() {
            var context = this, args = arguments;
            var later = function() {
                timeout = null;
                if (!immediate) {
                    deferred.resolve(func.apply(context, args));
                    deferred = this.$q.defer();
                }
            }.bind(this);
            var callNow = immediate && !timeout;
            if (timeout) {
                this.$timeout.cancel(timeout);
            }
            timeout = this.$timeout(later, wait);
            if (callNow) {
                deferred.resolve(func.apply(context, args));
                deferred = this.$q.defer();
            }
            return deferred.promise;
        }.bind(this);
    }
});
